<template>
  <content-placeholders
    class="product-card-wishlist"
    :class="{'_without-button': !showButtons}"
    rounded
  >
    <div class="product-card-wishlist__image-holder">
      <content-placeholders-img />
    </div>
    <div class="product-card-wishlist__content">
      <div class="product-card-wishlist__price product-card-price" style="margin-top: 8px;">
        <content-placeholders-text
          :lines="1"
          class="product-card-price__current"
          style="width: 65px;"
        />
        <content-placeholders-text
          :lines="1"
          class="product-card-price__old"
          style="width: 65px;"
        />
      </div>
      <content-placeholders-heading class="product-card-wishlist__name" style="margin-top: 12px;" />
      <div v-if="showButtons" class="product-card-wishlist__buttons-holder">
        <content-placeholders-img class="product-card-wishlist__button" style="height: 32px;" />
      </div>
    </div>
  </content-placeholders>
</template>

<script>
export default {
  name: 'ProductCardWishlistSkeleton',
  props: {
    showButtons: { type: Boolean, default: true },
  },
};
</script>

<style lang="less" scoped>
.product-card-wishlist {
  position: relative;
  width: 100%;
  height: auto;
  padding: @size-x5 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  &._without-button {
    height: 396px;
  }

  &__image-holder {
    flex: 0 0 88px;
    margin-right: @size-x5;
    margin-bottom: @size-x4;
    position: relative;
    height: auto;
  }

  &__content {
    flex: 0 1 422px;
    margin-right: @size-x4;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__name {
    margin: 0;
    max-height: 48px;
  }

  &__buttons-holder {
    margin-top: @size-x2;
    display: flex;
    max-width: 150px;
  }
}
</style>
